import * as React from "react";
import classnames from 'classnames';

interface IBoxProps {
    title: string,
    intro?: boolean,
    className?: string,
    contentClassName?: string,
    hidden?: boolean,
    boxRef?: React.RefObject<HTMLDivElement>,
    children?: React.ReactNode,
}

const Box = (props: IBoxProps) => (
    <div className={classnames(
        'll-box',
        {'ll-box-hidden': props.hidden === true},
        props.className
    )} ref={props.boxRef}>
        <h2 className="ll-box-title" id={props.title.replace(/\W+/g, '_').toLowerCase()}>
            {props.title}
        </h2>
        <div
            className={classnames(
                'll-box-content',
                {'ll-box-intro': props.intro === true},
                props.contentClassName
            )}
        >
            {props.children}
        </div>
    </div>
);

export default Box;
